export const COLUMN_CARD_HEIGHT = 52;
export const COLUMN_ROW_GAP = 8;

/**
 * The virtualiser's uniform row pitch. It is derived rather than written out because the virtualiser
 * positions rows arithmetically from it — if it ever disagrees with the rendered card, every row is
 * placed at the wrong offset and the list drifts as you scroll.
 */
export const COLUMN_ROW_HEIGHT = COLUMN_CARD_HEIGHT + COLUMN_ROW_GAP;

/**
 * Shared by the row collapse/expand animation and by the sliding of the rows below it. The two must
 * match, or the collapsing row and its successor stop moving in step and their backgrounds overlap.
 */
export const COLUMN_ROW_TRANSITION_MS = 300;

export const COLUMN_LIST_PADDING_TOP = 16;
export const COLUMN_LIST_PADDING_BOTTOM = 8;
